"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var URI = require("urijs");
var BASE_PATH = '';
function set(path) {
    BASE_PATH = path;
}
exports.set = set;
function compose() {
    return new URI(BASE_PATH);
}
exports.compose = compose;
